/**
 * Що можна поставити в офлайн-чергу, а що ні.
 *
 * Створення (POST) часто потребує id/пароля з відповіді — без сервера їх не
 * зібрати. Позначки мають власну чергу. Файли й логін теж не копимо.
 */

export type MutMethod = 'POST' | 'PUT' | 'PATCH' | 'DELETE';

const mutating = (method: string): method is MutMethod =>
  method === 'PUT' || method === 'PATCH' || method === 'DELETE';

export function shouldQueue(method: string, path: string): boolean {
  if (!mutating(method)) return false;
  if (!path.startsWith('/api/')) return false;
  if (path.startsWith('/api/auth/')) return false;
  if (path.startsWith('/api/marks')) return false;
  if (path.startsWith('/api/documents')) return false;
  if (path.startsWith('/api/export')) return false;
  if (path.startsWith('/api/import')) return false;
  if (path.includes('/file')) return false;
  return true;
}

/** Залишаємо нові правки, що з'явилися під час відправлення знімка черги. */
export function remainingOutbox<T extends { id: string }>(
  snapshot: T[],
  failed: T[],
  current: T[],
): T[] {
  const processed = new Set(snapshot.map(item => item.id));
  return [...failed, ...current.filter(item => !processed.has(item.id))];
}
